import { render, staticRenderFns } from "./ComplaintManagerView.vue?vue&type=template&id=53a20800&"
import script from "./ComplaintManagerView.vue?vue&type=script&lang=js&"
export * from "./ComplaintManagerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports